import Transfer from './Transfer';
import inputable from '../Form/inputable';
import { compose } from '../utils/func';
import Datum from '../Datum';
var bindProps = ['disabled', 'limit', 'format', 'prediction', 'separator'];
var exportTransfer = compose(inputable, Datum.hoc({
  bindProps: bindProps
}))(Transfer);
exportTransfer.displayName = 'ShineoutTransfer';
export default exportTransfer;